export default __webpack_public_path__ + "src/assets/icn-don-t-lose-crypto.c50699f2ea6fc0f35496b2b1891a0db8.svg";